import React, {Component} from "react";
import {css} from "aphrodite/no-important";
import {styles} from "./WeeklyActivityChartStyles";
import HourlyTick from "../components/HourlyTick";
import {Bar, BarChart, CartesianGrid, Rectangle, ResponsiveContainer, YAxis,} from "recharts";
import {colour} from "../style/base-theme";
import moment from "moment";
import {activityActions} from "../_actions";
import Sticky from "react-stickynode";
import {sortBy} from "lodash";

let data = [];

const timesArray = [
  "0000",
  "0100",
  "0200",
  "0300",
  "0400",
  "0500",
  "0600",
  "0700",
  "0800",
  "0900",
  "1000",
  "1100",
  "1200",
  "1300",
  "1400",
  "1500",
  "1600",
  "1700",
  "1800",
  "1900",
  "2000",
  "2100",
  "2200",
  "2300",
  "2400",
];

const fills = {
  off: "transparent",
  Normal: "#00C5FF",
  Warning: "url(#warningHash)",
  Urgent: "url(#urgentHash)",
  OffAlert: "url(#offHash)",
};

const CustomBar = (props) => {
  let { fill, value, payload, width, x } = props;

  Object.keys(payload.data).filter((item) => {
    if (
      value[0] === payload.data[item][0] &&
      value[1] === payload.data[item][1]
    ) {
      return (fill = fills[payload.data[item][2]]);
    }
    return false;
  });

  return (
    <Rectangle
      {...props}
      cursor="pointer"
      fill={fill}
      width={width - 11}
      x={x + 5}
      className={`recharts-bar-rectangle`}
    />
  );
};

export default class WeeklyActivityChart extends Component {
  constructor(props) {
    super(props);
    const { detail } = props.activity;

    let flattenedActivities =
      detail &&
      detail.activities.reduce((total, type) => {
        type.patterns.forEach((item) => {
          item.level = type.level;
          total.push(item);
        });

        return total;
      }, []);

    // let flattenedInactivities =
    //   detail &&
    //   detail.inactivities.reduce((total, type) => {
    //     type.patterns.forEach((item) => {
    //       item.level = type.level;
    //       // Flip the off and ons
    //       total.push({
    //         off: item.on,
    //         on: item.off,
    //         level: item.level,
    //       });
    //     });
    //
    //     return total;
    //   }, []);

    const sorted = flattenedActivities.reduce((total, item) => {
      const today = moment();
      let timestamp = moment.unix(item.on);
      let day;
      if (today.isSame(timestamp, "day")) {
        day = "Today";
      } else {
        day = moment.unix(item.on).format("ddd");
      }

      if (!total[day]) {
        total[day] = { name: day, timestamp: item.on, patterns: [] };
      }
      total[day].patterns.push(item);
      return total;
    }, []);

    data = sortBy(Object.keys(sorted).map((item) => {
      let previousEnd = 0;
      let counter = 0;
      let parts = {};
      parts.name = sorted[item].name;
      parts.timestamp = sorted[item].timestamp.toString();
      parts.dispatch = this.props.dispatch;
      let data = [];
      for (var i = 0; i < sorted[item].patterns.length; i++) {
        const part = sorted[item].patterns[i];
        if(part.off === part.on) continue;

        const start = Number(moment.unix(part.on).format("HHmm"));
        const end = Number(moment.unix(part.off).format("HHmm"));
        parts[counter] = start - previousEnd;
        let newEnd = end;
        if (end - start < 0) newEnd = 2400;
        parts[counter + 1] = newEnd - start;
        data.push([previousEnd, start, "off"]);
        data.push([start, newEnd, part.level]);
        previousEnd = newEnd;
        counter += 2;
      }
      parts.data = data;
      return parts;
    }), ['timestamp']);
  }

  handleClick(props) {
    // const {
    //   activity:{
    //     detail,
    //     activityFrequency
    //   }
    // } = this.props
    //
    // let hit = false
    //
    // for (var i = detail.available.length-1; i >= 0; i--) {
    //   if (!hit && this.props.activity.detailItem > detail.available[i]) {
    //     hit = true
    //     this.props.dispatch(activityActions.setDetailItem(detail.available[i]))
    //   }
    // }

    props.dispatch(activityActions.setActivityFrequency("day"));
    props.dispatch(
      activityActions.setDetailItem(
        moment.unix(props.timestamp).startOf("day").unix()
      )
    );
  }

  render() {
    const ChartX = () => (
      <div className={css(styles.chartX)}>
        {data.map((item, i) => {
          return (
            <div className={css(styles.chartXItem)} key={i}>
              <strong className={css(styles.chartXTitle)}>{item.name}</strong>
            </div>
          );
        })}
      </div>
    );

    return (
      <div className={css(styles.chartWrapper)}>
        <Sticky top="#header" innerZ={200}>
          <ChartX />
        </Sticky>
        <ResponsiveContainer>
          <BarChart
            width={600}
            height={600}
            data={data}
            barCategoryGap={-1}
            margin={{ top: 15, right: 15, left: -25, bottom: 0 }}
          >
            <defs>
              <pattern
                id="urgentHash"
                width="4"
                height="10"
                patternUnits="userSpaceOnUse"
                patternTransform="rotate(-45 50 50)"
              >
                <line
                  stroke={colour.brand.red}
                  opacity={0.5}
                  strokeWidth="20px"
                  y2="10"
                />
                <line
                  stroke={colour.grey[200]}
                  opacity={0.5}
                  strokeWidth="2px"
                  y2="10"
                />
              </pattern>{" "}
              <pattern
                id="offHash"
                width="14"
                height="10"
                patternUnits="userSpaceOnUse"
                patternTransform="rotate(45 50 50)"
              >
                <line
                  stroke={colour.brand.purple}
                  opacity={1}
                  strokeWidth="28px"
                  y2="10"
                />
                <line
                  stroke={colour.grey[200]}
                  opacity={0.5}
                  strokeWidth="5px"
                  y2="10"
                />
              </pattern>
              <pattern
                id="warningHash"
                width="14"
                height="10"
                patternUnits="userSpaceOnUse"
                patternTransform="rotate(-45 50 50)"
              >
                <line
                  stroke={colour.assisted.primaryGradientTop}
                  opacity={0.5}
                  strokeWidth="28px"
                  y2="10"
                />
                <line
                  stroke={colour.grey[300]}
                  opacity={0.5}
                  strokeWidth="5px"
                  y2="10"
                />
              </pattern>
            </defs>
            <YAxis
              reversed={true}
              tickLine={false}
              ticks={timesArray}
              domain={[0, 2400]}
              tick={<HourlyTick />}
              stroke={colour.grey[300]}
              fontFamily="Source Sans Pro"
              fontSize={14}
            />
            <Bar
              shape={CustomBar}
              background={{ fill: "#ffffff", stroke: `${colour.grey[500]}` }}
              type="monotone"
              dataKey="0"
              stackId="a"
              onClick={this.handleClick}
            />
            {[...Array(50).keys()].map(i => (
              <Bar
                shape={CustomBar}
                type="monotone"
                dataKey={i+1}
                stackId="a"
                onClick={this.handleClick}
              />
            ))}
            <CartesianGrid stroke={colour.grey[500]} vertical={false} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    );
  }
}
